<template>
  <div>
  
  <div class="card border-info" >
    
    <div class="card-header bg-transparent border-info ">
          <p>
            <i style="color:blue;" class="fas fa-ruler-combined mr-3" aria-hidden="true"></i>
            <strong>TABELLA MISURE</strong></p> 
          
    </div>


    <div class="card-body"> 
   
     <div  class="table-responsive">
      <table class="table table-sm" id="table">
        <thead>
          <tr>
          <th v-for="(col,index) in filteredSizes" :key="index">
                         
              <p class="btn text-nowrap" type="button" @click="provide(col)"

              v-bind:class="[{ active: col.new == 'yes' && col.selected == 1 },{ no_active: col.new == 'no' && col.selected == 1 }]"
              
              >{{col.size}}</p>
                    
          </th>
          </tr>
        </thead>
      </table>
      
  </div>
  
    <!-- BODY CARD -->
  </div>
  <small  id="sizeHelp" class="form-text text-muted ml-3"><strong>Selezionare una misura dall'elenco.</strong></small>    
  <div class="ml-2 mr-2 mb-2 mt-2">
    <strong class="mt-3 ml-3">Filtra misura</strong> 
    <input id="cerca" class="form-control " type="text" name="query" v-model="filterKey">
  </div>

</div>
  

   
  </div>
</template>

<script>


import api from '@/api'



  export default {
    props:['selection'],
     components: {},
    data () {
      return {
        
        cols         : [], 
        isActive     : [],
        newSize      : '',
        showDiv      : false,
        
        candidates   : [],
        filterKey    : ''
        
      }
    },
    watch :
    {

    },
    
  
    computed: {
      //...mapGetters(['','product']),
      
      filteredSizes : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.cols
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            if(key=='size')
            {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            }
          })
        })
      }
        return items
     },
  
      
      
    },
    mounted()
    {   
     
    },
    created () 
    {
      this.getData()
    },
    methods: 
    {

    
     // ...mapActions(['createStockGrid']),
    provide: function(item)
    {
      
      
      if(item.new == 'no')
      {
        return
      }

      item.new = 'yes'
      
      item.selected = item.selected == 0 ? 1 : 0
    	      
      if(this.candidates.indexOf(item.sizeId) == -1)
      {
       
       
      	this.candidates.push(item.sizeId)
      }
      else
      {
       
      	this.candidates.splice(this.candidates.indexOf(item.sizeId), 1);
      }
      
      
      this.sendMessage()
    
    },

    contains: function(arr, item)
    {
      

      

      if(item.new == 'no')
      {
        return arr.indexOf(item.sizeId) != -1 && item.new == 'no';  
      }
      else
      {
        return arr.indexOf(item.sizeId) != -1;
      }
    },
     
 
      
      sendMessage() 
      {
        
        var sizes = []
        
        this.cols.forEach(item=>{
          if(item.selected == 1)
          {
            
            sizes.push(item)
          }
        })

        
        this.$emit('update',sizes)
        

      },  
      async getData()
      {
        const json    = {'sp':'spSizeList'}
        await api.post(json).then(res => {
          if(res.status==200)
            {
               var sizes =  res.data.recordsets[0]
            
            sizes.forEach(item=>{
              item.selected = 0
              item.new = 'yes'
              
             
              this.cols.push(item)  
            })
            
            

            this.selection.forEach(item=>{
              
              this.cols.forEach(col=>{
                if(item.sizeId==col.sizeId)
                {
                  col.selected = 1
                  
                  if(item.new == 'yes')
                  {
                    col.new = 'yes'
                  }
                  else
                  {
                    col.new = 'no'
                  }
                 
                  
                  
                  this.candidates.push(item.sizeId)
                }
              
              })
              
            })
            
            
            
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
        





  
      },
      
      

      
      

    }
  }
</script>
<style scoped>
.active{
  color            : black;
  background-color :#9ACD32
}
.no_active{
  color            : black;
  background-color : gray;
}

p {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}
.green{
  background-color: #41B883;
}

  li  {font-weight : bold;}
  a:hover { 
    cursor        : pointer;
  }
  span:hover {
      cursor        : pointer;
  }
  .list tr:hover {
    cursor        : pointer;
  }

.btn_pointer
{
    cursor        : pointer;
}
  
  .pointer:hover
{
  _background-color: blue;
  _color: white;
  cursor: pointer;
}
 
  .my-custom-scrollbar {
    position  : relative;
    height    : 400px;
    overflow  : auto;
    }
  .table-wrapper-scroll-y {
    display   : block;
  }
  h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.selected
{
  color        : rgb(0, 255, 123);  
  font-family  : 'Roboto Condensed';
  font-weight  : bold;
  
  
}
</style>
